import { SvgIcon } from "@mui/material";

const SubItemOpenIcon = () => {
  return (
    <SvgIcon
      width="10"
      height="16"
      viewBox="0 0 10 16"
      style={{ transform: "scale(0.5)" }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.38379 15.2283L9.38379 0.771773C9.38379 0.0876705 8.5577 -0.260835 8.06721 0.229654L0.838962 7.45791C0.542088 7.75478 0.542088 8.24527 0.838962 8.54227L8.06721 15.7705C8.5577 16.2609 9.38379 15.9124 9.38379 15.2283Z"
        fill="#666666"
      />
    </SvgIcon>
  );
};

export default SubItemOpenIcon;
